import { useMemo, useState } from "react";

import { PaginatedResponse } from "api/common/types/response.types";
import { useDeleteProductMutation } from "api/memberPortal/product/product.api";
import { Product } from "api/memberPortal/project/product/product.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";
import DeleteModal from "components/UI/DeleteModal";

import buildPidColumns from "./ProductsInDraft.columns";

interface NewTableProps {
  products: PaginatedResponse<Product> | undefined;
  isLoading: boolean;
  handleShowProductFormModal: (_product: Product) => void;
  setProduct: (_product: Product) => void;
}

const ProductsInDraftTable = ({
  products,
  isLoading,
  setProduct,
  handleShowProductFormModal,
}: NewTableProps) => {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [productDelete, setProductDelete] = useState<Product | undefined>(
    undefined,
  );
  const [triggerDelete] = useDeleteProductMutation();

  const handleDeleteDraft = async () => {
    const id = productDelete?.product_id ?? false;
    if (!id) return;

    await triggerDelete(id);

    setShowDeleteModal(false);
    setProductDelete(undefined);
  };

  const pidColumns = useMemo(
    () =>
      buildPidColumns({
        setShowDeleteModal,
        handleShowProductFormModal,
        setProduct,
        setProductDelete,
      }),
    [
      setShowDeleteModal,
      handleShowProductFormModal,
      setProduct,
      setProductDelete,
    ],
  );

  return (
    <>
      <DefaultDataGrid
        columns={pidColumns}
        rows={products?.results}
        loading={isLoading}
        title={"Products In Draft"}
        getRowId={(row) => row.v_id}
        pageSizeOptions={[5, 10, 20]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 20 },
          },
        }}
      />

      {showDeleteModal && (
        // @ts-ignore Using the delete modal - using legacy delete not tsx
        <DeleteModal
          show={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          type="Draft"
          deleteFunction={handleDeleteDraft}
        />
      )}
    </>
  );
};

export default ProductsInDraftTable;
